<template>
    <div class="ljp">
        <div class="enentDiv">
            <div style="width: 50%;">
                <div style="height: 70px;display: flex;align-items: center;justify-content: flex-start;">
                    <div style="margin-left: 30px;">
                        <el-date-picker v-model="search" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                            @change='searchFun(search)'>
                        </el-date-picker>
                    </div>
                </div>

                <div style="width: calc(100% - 60px);text-align: center;margin-left: 30px;">
                    <el-table :data="robotList" :cell-style="{borderColor:'#121a2a'}"
                        :header-cell-style="{background: 'rgb(27,48,71)',borderColor: '#121a2a'}"
                        :row-style="{background: 'rgb(27,48,71)',color: 'white'}">
                        <!-- <el-table-column label="序号" align="center" type="index"></el-table-column> -->
                        <el-table-column label="机器人名称" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.robotName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="视频数量" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" @click='getVideo(scope.row)' type="primary">
                                    {{ scope.row.videoNum }}
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column label="事件数量" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" @click='getEvent(scope.row)' type="primary">
                                    {{ scope.row.eventNum }}
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column label="路线地图名称" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.routeName }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div style="text-align: left;margin-left: 25px;margin-top: 10px;">
                    <el-pagination layout="prev, pager, next" :current-page='page' :total="total"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
            <div style="width: 50%;" v-if="ifEvent">
                <div style="height: 70px;display: flex;align-items: center;justify-content: flex-start;">
                    <div style="margin-left: 30px;font-size: 22px;color: white;font-weight: 600;">
                        事件列表
                    </div>
                </div>
                <div style="width: calc(100% - 60px);text-align: center;margin-left: 30px;">
                    <el-table :data="eventList" :cell-style="{borderColor:'#121a2a'}"
                        :header-cell-style="{background: 'rgb(27,48,71)',borderColor: '#121a2a'}"
                        :row-style="{background: 'rgb(27,48,71)',color: 'white'}">
                        <!-- <el-table-column label="序号" align="center" type="index"></el-table-column> -->
                        <el-table-column label="事件名称" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.eName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="事件分类" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.eClassify }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="处理时间" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.updDate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="处理结果" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.results }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="实际处理人" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.staffName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="原定处理人" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.targetUserName }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button @click="handleClickEvent(scope.row)" type="text" size="small">查看</el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
                <div style="text-align: left;margin-left: 25px;margin-top: 10px;">
                    <el-pagination layout="prev, pager, next" :current-page='eventPage' :total="eventTotal"
                        @current-change="handleCurrentEvent">
                    </el-pagination>
                </div>
            </div>

            <div style="width: 50%;" v-else>
                <div style="height: 70px;display: flex;align-items: center;justify-content: flex-start;">
                    <div style="margin-left: 30px;font-size: 22px;color: white;font-weight: 600;">
                        视频列表
                    </div>
                </div>
                <div style="width: calc(100% - 60px);text-align: center;margin-left: 30px;">
                    <el-table :data="videoList" :cell-style="{borderColor:'#121a2a'}"
                        :header-cell-style="{background: 'rgb(27,48,71)',borderColor: '#121a2a'}"
                        :row-style="{background: 'rgb(27,48,71)',color: 'white'}">
                        <!-- <el-table-column label="序号" align="center" type="index"></el-table-column> -->

                        <el-table-column label="时段" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.TIME_INTERVAL }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="时长" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.TIMES }} 分钟</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button @click="handleClickVideo(scope.row)" type="text" size="small">查看</el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
                <div style="text-align: left;margin-left: 25px;margin-top: 10px;">
                    <el-pagination layout="prev, pager, next" :current-page='videoPage' :total="videoTotal"
                        @current-change="handleCurrentVideo">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVideo" width="80%">
            <video-player class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
            ></video-player>
        </el-dialog>
        <el-dialog title="基本信息" :visible.sync="dialogEvent" width="80%">
            <div style="color: rgb(230,230,230);width: 100%;display: flex;justify-content: space-between;">
                <div style="width: 50%;">
                    <div class="evevtLi">
                        <div class="evevtTitle">机器人编号</div>
                        <div>{{ eventInfo.number }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">事件分类</div>
                        <div>{{ eventInfo.eClassifyName }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">处理结果</div>
                        <div>{{ eventInfo.resultsName }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">车辆运行区域</div>
                        <div>{{ eventInfo.area }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">线路地图名称</div>
                        <div>{{ eventInfo.routeName }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">实际处理人</div>
                        <div>{{ eventInfo.actualStaffName }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">路线地图地址</div>
                        <div>
                            <el-image style="width: 100px; height: 100px;" :src="eventInfo.phoneAddress"
                                :preview-src-list="[eventInfo.phoneAddress]">
                            </el-image>
                        </div>
                    </div>
                </div>
                <div style="width: 50%;">
                    <div class="evevtLi">
                        <div class="evevtTitle">机器人简称</div>
                        <div>{{ eventInfo.rName }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">事件类型</div>
                        <div>{{ eventInfo.eName }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">处理时间</div>
                        <div>{{ eventInfo.updDate }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">车辆运行楼层</div>
                        <div>{{ eventInfo.floor }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">地图坐标点</div>
                        <div>{{ eventInfo.position }}</div>
                    </div>
                    <div class="evevtLi">
                        <div class="evevtTitle">原定处理人</div>
                        <div>{{ eventInfo.targetStaffName }}</div>
                    </div>
                </div>
            </div>
            <div style="width: 100%;">
                <div class="evevtLi">
                    <div class="evevtTitle" style="color: rgb(240,240,240);">相关图片</div>
                    <div v-for="(obj, index) in eventInfo.jkEventImgInfoList" :key="index">
                        <el-image style="width: 100px; height: 100px;margin: 0 10px;" :src="obj.imgUrl"
                            :preview-src-list="[obj.imgUrl]">
                        </el-image>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        robotVideo,
        robotEventList,
        robotVideoList,
        eventDetail
    } from '@/api/admin'
    import {
        getItem
    } from '@/utils/auth'

    export default {
        data() {
            return {
                resUrl: 'https://rest.concoai.com/file/',
                dialogVideo: false,
                dialogEvent: false,
                robotList: [],
                search: this.getNowTime(),
                total: 0,
                page: 1,
                ifEvent: true,
                videoList: [],
                videoTotal: 0,
                videoPage: 1,
                eventNumber: '',
                eventList: [],
                eventTotal: 0,
                eventPage: 1,
                eventInfo: {},
                videoInfo: {},
                playerOptions: {
                  autoplay: true,
                  muted: true,
                  loop: true,
                  preload: 'auto',
                  language: 'zh-CN',
                  aspectRatio: '14:6',
                  fluid: true,
                  width: 200,
                  sources: [{
                    type: 'video/mp4',
                    src: ''
                  }]
                }
            }
        },
        mounted() {
            this.robotVideo({
                tenantInfoId: getItem('userInfo').tenantInfoId,
                dateTime: this.search,
                page: this.page,
                pageSize: 10
            })
        },
        methods: {
            handleCurrentVideo(res) {
                this.videoPage = Number(res)
                this.robotVideoList({
                    number: this.eventNumber,
                    dateTime: this.search,
                    page: this.videoPage,
                    pageSize: 10
                })
            },
            handleClickEvent(obj) {
                let that = this
                eventDetail(obj.eventId).then(res => {
                    if (res.data) {
                        that.dialogEvent = true
                        that.eventInfo = res.data
                    }
                })
            },
            handleClickVideo(res) {
                this.dialogVideo = true
                this.videoInfo = res
                this.playerOptions.sources[0].src = res.video
            },
            handleCurrentChange(res) {
                this.page = Number(res)
                this.robotVideo({
                    tenantInfoId: getItem('userInfo').tenantInfoId,
                    dateTime: this.search,
                    page: this.page,
                    pageSize: 10
                })
            },
            handleCurrentEvent(res) {
                this.eventPage = Number(res)
                this.robotEventList({
                    number: this.eventNumber,
                    dateTime: this.search,
                    page: this.eventPage,
                    pageSize: 10
                })
            },
            searchFun(res) {
                this.search = res
                this.robotVideo({
                    tenantInfoId: getItem('userInfo').tenantInfoId,
                    dateTime: this.search,
                    page: this.page,
                    pageSize: 10
                })
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, "0");
                date = date.toString().padStart(2, "0");
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            },
            getVideo(obj) {
                this.ifEvent = false
                this.eventNumber = obj.number
                this.videoPage = 1
                this.eventPage = 1
                this.robotVideoList({
                    number: this.eventNumber,
                    dateTime: this.search,
                    page: this.videoPage,
                    pageSize: 10
                })
            },
            getEvent(obj) {
                this.ifEvent = true
                this.eventNumber = obj.number
                this.eventPage = 1
                this.videoPage = 1
                this.robotEventList({
                    number: this.eventNumber,
                    dateTime: this.search,
                    page: this.eventPage,
                    pageSize: 10
                })
            },
            robotVideoList(resData) {
                let that = this
                robotVideoList(resData).then(res => {
                    that.videoList = res.data.list
                    that.videoTotal = res.data.totalNum
                })
            },
            robotEventList(resData) {
                let that = this
                robotEventList(resData).then(res => {
                    that.eventList = res.data.list
                    that.eventTotal = res.data.totalNum
                })
            },
            robotVideo(resData) {
                let that = this
                robotVideo(resData).then(res => {
                    that.robotList = res.data.list
                    that.total = res.data.totalNum
                })
            }
        }
    }
</script>

<style scoped="scoped" lang="less">
    html,
    body {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .enentDiv {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
    }

    .evevtLi {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 15px 0;

        .evevtTitle {
            width: 150px;
            padding-right: 20px;
            text-align: right;
        }
    }

    .enentDiv /deep/ .el-table tbody tr:hover>td {
        background-color: rgb(15, 37, 54) !important
    }

    .enentDiv /deep/ .btn-next {
        background-color: rgb(27, 48, 71);
        color: white;
    }

    .enentDiv /deep/ .btn-prev {
        background-color: rgb(27, 48, 71);
        color: white;
    }

    .enentDiv /deep/ .number {
        background-color: rgb(27, 48, 71);
        color: white;
    }

    .enentDiv /deep/ .active {
        color: #426ab3;
    }

    .enentDiv /deep/ .el-table__empty-block {
        background-color: rgb(27, 48, 71);
    }

    .ljp /deep/ .el-dialog {
        background-color: rgb(27, 48, 71);
    }

    .ljp /deep/ .el-dialog__title {
        color: white;
    }

    .el-table::before {
        height: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/page/event/index.vue